import { IconProps } from './IconProps';

export const Checkmark = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="13"
      height="10"
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.2416 10L0 5.17516L1.52211 3.83703L4.33675 7.0384L11.3754 0L12.8083 1.43312L4.2416 10Z"
        fill={props.fill ?? '#3F8707'}
      />
    </svg>
  );
};
